import { render, staticRenderFns } from "./classifySearch.vue?vue&type=template&id=7f1043dc&scoped=true"
import script from "./classifySearch.vue?vue&type=script&lang=js"
export * from "./classifySearch.vue?vue&type=script&lang=js"
import style0 from "./classifySearch.vue?vue&type=style&index=0&id=7f1043dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1043dc",
  null
  
)

export default component.exports